import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Emoji } from '@components/Emoji.tsx'
import styles from './ErrorBoundary.module.css'

type Props = { children: ReactNode }
type State = { error: Error | null }

// Class component because React has no hook equivalent for componentDidCatch.
// Catches render errors anywhere below it so a single bad render no longer
// white-screens the whole SPA.
export class ErrorBoundary extends Component<Props, State> {
	override state: State = { error: null }

	static getDerivedStateFromError(error: Error): State {
		return { error }
	}

	override componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('Uncaught render error:', error, info.componentStack)
	}

	override render() {
		if (this.state.error === null) return this.props.children
		return (
			<main className={styles.screen}>
				<span className={styles.emoji}>
					<Emoji char="🫠" label="Melting face" />
				</span>
				<h1 className={styles.title}>Something broke</h1>
				<p className={styles.hint}>
					Sorry — that wasn't meant to happen. Reloading usually sorts
					it.
				</p>
				<button
					type="button"
					className={styles.reload}
					onClick={() => window.location.reload()}
				>
					Reload
				</button>
			</main>
		)
	}
}
